import { useState } from 'react';
import { Dropdown, Space, Select, Button, Avatar, App } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { optionalCountryChange } from '@/app/reducers/headerSlice';
import { useI18n } from '@/i18n';

export default function Index() {
  const { message } = App.useApp();
  const dispatch = useDispatch();
  const location = useLocation();
  const $t = useI18n('component.header.language');
  const { value: country } = useSelector(state => state.country);
  const { optionalCountryId, saleCountry } = useSelector(state => state.lang);
  const [countryOpen, setCountryOpen] = useState(false);
  const [countryId, setCountryId] = useState(optionalCountryId);

  const baseCountryOptionsRender = (option) => (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      <Avatar size="small" shape="square" style={{ borderRadius: 0, width: 22, height: 16, marginRight: 5 }} icon={<img src={country.find(item => `${item.id}` === `${option.value}`)?.icon} alt='' />} />
      {option.label}
    </span>
  );

  const handleOnOptionalCountry = (value) => {
    setCountryId(value);
  };

  const handleClickCountry = () => {
    if (saleCountry?.length) {
      const saleCountryInfo = saleCountry.find(item => +item.id === +countryId);
      if (!saleCountryInfo) {
        return message.info('当前商品可销往国家为' + saleCountry.map(item => item.name));
      }
    }
    dispatch(optionalCountryChange(countryId));
    setCountryOpen(false);
  };

  const relatedCountryItems = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} onClick={e => e.stopPropagation()}>
          <Select value={+countryId} style={{ width: 180, margin: '10px auto' }} onChange={handleOnOptionalCountry} options={country} fieldNames={{ label: 'name', value: 'id' }} labelRender={baseCountryOptionsRender} optionRender={baseCountryOptionsRender} />
          <Button type='primary' block onClick={handleClickCountry}>{$t('save')}</Button>
        </div>
      )
    }
  ];

  const onOpenCountry = (open) => {
    if (['/plan/submit', '/cart/submit'].includes(location.pathname)) {
      message.info('结算页不允许修改');
    } else {
      setCountryId(optionalCountryId);
      setCountryOpen(open);
    }
  };

  return (
    <Dropdown open={countryOpen} onOpenChange={onOpenCountry} trigger={['click']} destroyOnHidden={true} menu={{ items: relatedCountryItems }}>
      <span className='header-dropdown-trigger' onClick={(e) => e.stopPropagation()}>
        <Space>
          {$t('Ship to')}
          <Avatar size="small" shape="square" style={{ borderRadius: 0, width: 22, height: 16, marginRight: 5 }} icon={<img src={country.find(item => `${item.id}` === `${optionalCountryId}`)?.icon} alt='' />} />
          <DownOutlined />
        </Space>
      </span>
    </Dropdown>
  );
}